class CustomerReviewsSlider extends HTMLElement {
    constructor() {
        super();
        this.slider = null;
        this.scrollbar = null;
        this.prevButton = null;
        this.nextButton = null;
    }

    connectedCallback() {
        // Wait for Swiper library to be loaded
        if (typeof Swiper === 'undefined') {
            setTimeout(() => this.connectedCallback(), 100);
            return;
        }

        // Small delay to ensure DOM is ready
        setTimeout(() => this.initSlider(), 50);
    }

    initSlider() {
        const swiperElement = this.querySelector('.customer-reviews__slider');

        // Query scrollbar from parent section since it's outside the custom element
        const section = this.closest('.customer-reviews');

        // Query navigation buttons
        this.prevButton = section.querySelector('[data-nav-prev]');
        this.nextButton = section.querySelector('[data-nav-next]');

        if (!swiperElement) {
            console.error('Featured Articles: Swiper element not found');
            return;
        }

        this.slider = new Swiper(swiperElement, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            grabCursor: true,
            navigation: {
                prevEl: this.prevButton,
                nextEl: this.nextButton,
            }
        });
    }

    disconnectedCallback() {
        if (this.slider) {
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }
}

customElements.define('customer-reviews-slider', CustomerReviewsSlider);
